import { IAction, isType } from '@zaibot/fsa';

import METADATA_CHANGE from './actions/CHANGE';
import METADATA_RESET from './actions/RESET';

export interface IState {
    docId: string;
    docName: string;
    pageId: number;
    pageName: string;
    pageNumber: number;
    pageUrl: string;
    tenantId: string;
    tenantName: string;
    breadcrumb: string;
    mailToName: string;  
    mailToAddress: string;    
}
const emptyState: IState = {
    docId: null,
    docName: null,
    pageId: null,
    pageName: null,
    pageNumber: null,
    pageUrl: null,
    tenantId: null,
    tenantName: null,
    breadcrumb: null,    
    mailToName: null,
    mailToAddress: null,
};

export const reducer = (state = emptyState, action: IAction) => {
    if (isType(action, METADATA_CHANGE)) {
        return {
            ...state,
            docId: action.payload.docId,
            docName: action.payload.docName,
            pageCount: action.payload.pageCount,
            pageId: action.payload.pageId,
            pageName: action.payload.pageName,
            pageNumber: action.payload.pageNumber,
            pageUrl: action.payload.pageUrl,
            tenantId: action.payload.tenantId,
            tenantName: action.payload.tenantName,
            breadcrumb: action.payload.breadcrumb,
            mailToName: action.payload.mailToName,
            mailToAddress: action.payload.mailToAddress,
        };
    }
    if (isType(action, METADATA_RESET)) {
        return {
            ...state,
            docId: null,
            docName: null,
            pageCount: null,
            pageId: null,
            pageName: null,
            pageNumber: null,
            pageUrl: null,
            tenantId: null,
            tenantName: null,
            breadcrumb:null,
            mailToAddress: null,
            mailToName: null,
        };
    }
    return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/meta/reducer.tsx